module.exports = __webpack_public_path__ + "img/reddit.6b798a38.svg";